// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"348":"chat","389":"photo-manager","984":"workshop"}[chunkId] + "." + {"348":"055cc413b076f5d209a0","389":"ab7ab4d3b19cd04e5806","984":"428f494a773abd7de41d"}[chunkId] + ".js";
};